import React, { useState, useEffect } from "react";
import "./partsaddtextfields.scss";
import { useNavigate } from "react-router-dom";
import { selectLanguageAction } from "../../actions/partAction";
import { useDispatch } from "react-redux";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Button,
} from '@mui/material';
import { hasAnyPermission, hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const PartsAdd_s = ({
  vehicle,
  states,
  handleChange,
  mode,
  getVehicleList,
  oncreatepart,
  handleFileUploads,
  handleDeletefile,
  fileInputRefs,
  Vehicle_file,
  AllVehicleList,
  state,
  onupdatepart,
  handleConfirmationPopup,
  selectLanguage,
  handleSelectLanguage,
  editLanguage,
  handleChangedropdown,
  selectedVehicles,
  Country_name,
  meta,
  discountGroups,
  setDiscountGroups,
}) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const submit_addpart = () => {
    navigate("/partslist");
  };
  const dispatch = useDispatch();
  const [language, setLanguage] = useState([]);
  async function languageListData() {
    let response = await dispatch(selectLanguageAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setLanguage(response?.data?.data);
    }
  }

  const handleInputChange = (id, value) => {
    if (!/^\d*$/.test(value)) return;
    setDiscountGroups((prev) => {
      const updatedGroups = prev.map((group) =>
        group.discount_group_id === id ? { ...group, discount_price: value } : group
      );

      // If group is not found, add it
      if (!updatedGroups.some((group) => group.discount_group_id === id)) {
        updatedGroups.push({ discount_group_id: id, discount_price: value });
      }

      return updatedGroups;
    });
  };

  const handleBlur = (id, value) => {
    if (value === "") {
      setDiscountGroups((prev) =>
        prev.map((group) =>
          group.discount_group_id === id ? { ...group, discount_price: 0 } : group
        )
      );
    }
  };


  useEffect(() => {
    languageListData();
  }, []);

  return (
    <div className="parts_add_textfieldcontsiners">
      <div className="parts_add_textfields">
        <div className="pgmlistdropdown_div">
          <div class="input-wrapper">

            <FormControl className="multiselect_part">
              <label className="part_label" for="first">{t('partlist.selectvehicle')}</label>
              <Select className="multipleSelect_part"
                labelId="vehicle-label"
                id="vehicle"
                name="vehicle"
                multiple
                inputProps={{ className: 'multiselect_input' }}
                value={mode === "Edit" ? vehicle : selectedVehicles}
                onChange={handleChangedropdown}
                renderValue={(selected) => {
                  const selectedRoleNames = selected?.map((data) => data.name);
                  const alredySelected = vehicle?.map((item) => item.name);
                  return mode === "Edit" ? alredySelected.join(", ") : selectedRoleNames.join(", ");
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: '200px',
                    },
                  },
                }}
              >
                {AllVehicleList?.map((data) => (
                  <MenuItem className="partlist_menu" key={data.id} value={data}>
                    <Checkbox checked={mode === "Edit" ? vehicle?.some((datalist) => datalist.id === data.id) : (selectedVehicles?.some((role) => role.id === data.id))} />
                    <ListItemText value={data.id} primary={data.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="pgmlistdropdown_div">
          <div class="input-wrapper">
            <label className="required" for="search">MOQ</label>
            <input
              type="text"
              name="minimum_order_quantity"
              id="minimum_order_quantity"
              value={mode === "Edit" ? state?.minimum_order_quantity : states?.minimum_order_quantity}
              onChange={handleChange}
              className="input_parts_orders"
            />
          </div>
        </div>
        {/* <div className="parts_add_group_textfields"> */}
          {meta?.map((item) => {
            const existingDiscount = discountGroups.find((group) => group?.discount_group_id === item?.id);
            return (
              <div className="pgmlistdropdown_div" key={item?.id}>
                <div className="input-wrapper">
                  <label>{item?.group_name}</label>
                  <input
                    type="text"
                    className="input_parts_orders"
                    placeholder={t("addparts.enterDiscountPrice")}
                    value={existingDiscount ? existingDiscount.discount_price : ""}
                    onChange={(e) => handleInputChange(item?.id, e.target.value)}
                    onBlur={(e) => handleBlur(item?.id, e.target.value)}
                  />
                </div>
              </div>
            )
          })}
        {/* </div> */}
        <div className="pgmlistdropdown_div">
          <div class="input-wrapper">
            <label for="first">{t('addparts.selectlanguage')}</label>
            <select
              className="selectpartsaddtextfields"
              onChange={handleSelectLanguage}
              value={mode === "Edit" ? editLanguage : selectLanguage}
            >
              <option value="">{t('addparts.selectlanguage')}</option>
              {language?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.language}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="parts_add_textfields">
        
      </div>
      <div>
        {hasAnyPermission([PERMISSIONS.CAN_UPDATE_PART || PERMISSIONS.CAN_CREATE_PART]) && (
          <button
            className="SubmitAddparts"
            onClick={handleConfirmationPopup}
            disabled={
              //TODO: To be enabled as per requirement
              // selectedVehicles?.length === 0 ||
              states?.name === "" ||
              states?.part_id === "" ||
              states?.price === "" ||
              states?.discount === "" ||
              states?.minimum_order_quantity === "" ||
              state?.name === "" ||
              state?.part_id === "" ||
              state?.price === "" ||
              state?.discount === "" ||
              state?.minimum_order_quantity === ""
              //TODO: To be enabled as per requirement
              // vehicle?.length === 0
            }
          >
            {mode === "Edit" ? t('editparts.update') : t('addparts.create')}
          </button>
        )}
      </div>
    </div>
  );
};

export default PartsAdd_s;
